export const OperationTypes = {
    CREATE: 'create',
    MODIFY: 'modify'
}
